//指定されたシートID配列全ての当該シート名とツリー構造(Book1 > Sheet1 > Sheet1-1 >)を文字列で返す
import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer';

export type LinkSheetNameType = {
  sheetName: string;
  linkTreeName: string;
}

const useSheetTreeNamesForLink = (bookName?: string, sheetIds?: string[]): LinkSheetNameType[] => {
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const sheetDb = useSelector((state: RootState) => state.sheetDb);
  const linkSheetNames: LinkSheetNameType[] = [];

  const makeTreeName = (sheet_id: string): string => {
    let sheetNames: string[] = [];
    let folderName: string = '';
    const tree_id = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].sheetId === sheet_id)[0];
    const targetTree = sheetTreeDb.sheetTrees[tree_id];

    if(targetTree?.parentSheetId) {
      if((targetTree.parentSheetId !== '') && (targetTree.parentSheetId !== undefined)){
        sheetNames.push(sheetDb.sheets[targetTree.parentSheetId].name + ' > ');
        sheetNames.push(makeTreeName(targetTree.parentSheetId));
      }
    }
    for(let i = sheetNames.length - 1; i >= 0; i--) {
      folderName = folderName + sheetNames[i];
    }
    return folderName;
  }

  sheetIds?.forEach(sheetId => {
    const sheetName = sheetDb.sheets[sheetId].name;
    let linkSheetName:LinkSheetNameType = { sheetName: sheetName, linkTreeName : '' };
    let folderName:string = '';

    folderName = makeTreeName(sheetId);
    if (folderName.length > 0 )linkSheetName.linkTreeName = bookName + ' > ' + folderName;
    else                       linkSheetName.linkTreeName = bookName + ' > ';

    linkSheetNames.push(linkSheetName)
  })

  return linkSheetNames;
}

export default useSheetTreeNamesForLink;